/* eslint camelcase: 0 */
import { toFileProps } from './file'
import { Notice } from '@/infrastructure/network/Monitaro/schema/models'
import { INoticeProps, EmptyNoticePropsFactory } from '@/entities/Notice'

export const toNoticeProps = (props: Notice | null | undefined): INoticeProps => {
  if (!props) {
    return EmptyNoticePropsFactory()
  }

  const { id, category, title, content, properties, files, published_at, created_at, updated_at } = props

  // Handle files as object format
  let fileArray = null
  if (files) {
    if (Array.isArray(files)) {
      fileArray = files.map(toFileProps)
    } else if (typeof files === 'object') {
      // Convert object to array, filtering out non-file entries like 'image'
      fileArray = Object.keys(files)
        .filter((key) => !isNaN(Number(key)))
        .map((key) => toFileProps(files[key]))
    }
  }

  return EmptyNoticePropsFactory({
    id,
    category,
    title,
    content,
    properties,
    files: fileArray,
    publishedAt: published_at,
    createdAt: created_at,
    updatedAt: updated_at
  })
}
